import React, { useState } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import PropTypes from "prop-types";
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import GenericModal from '../../../../../components/modal/GenericModal';
import {CustomModalFooter, PrimaryActionButtonForModal} from '../../../styledComponents/styledComponents';
import { cuadroRequerimientosCopiarPlanCurricularCampanaAPI } from '../../../../../consumers/backendApisUrls';
import { useManagePostRequest } from '../../../../../hooks/useManagePostRequest/useManagePostRequest';

const ModalBody = styled.div`
    padding: 20px;
    background-color: #f8f9fa;
`;



const CopiarPlanModal = ({ showModal, title, campana, listCampanas, refetchData }) => {
    const [selectedCampana, setSelectedCampana] = useState(null);

    const [executeManagePostRequest] = useManagePostRequest();

    const handleChangeCampana = (e) => {
        setSelectedCampana(e.target.value);
    };

    const handleProcess = async () => {
        const payload = {
            IdCampanaOrigen: selectedCampana?.value,
            IdCampanaDestino: campana?.IdCampana
        };
        await executeManagePostRequest(cuadroRequerimientosCopiarPlanCurricularCampanaAPI(),
            payload,
            (res) => {
                refetchData();
                showModal();
            }, true,
            (err) => {
                console.log("error", err);
            }, true
        );
    };

    return (
        <GenericModal
            showModal={showModal}
            width="500px"
            titulo={title}
        >
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <InputSelect
                            label="Nombre de Campaña:"
                            options={listCampanas}
                            value={selectedCampana}
                            onChange={handleChangeCampana}
                            name="campana"
                            isRequired={false}
                            direction="row"
                        />
                    </Col>
                </Row>
            </ModalBody>
            <CustomModalFooter>
                <PrimaryActionButtonForModal onClick={handleProcess}>
                    Procesar
                </PrimaryActionButtonForModal>
            </CustomModalFooter>
        </GenericModal>
    );
};

CopiarPlanModal.propTypes = {
    showModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    campana: PropTypes.object.isRequired,
    listCampanas: PropTypes.array.isRequired,
    refetchData: PropTypes.func.isRequired
};

export default CopiarPlanModal;
